import WatchlistService from 'src/modules/watchlist/watchlistService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'WATCHLIST_FORM';

const watchlistFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: watchlistFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await WatchlistService.find(id);
      }

      dispatch({
        type: watchlistFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: watchlistFormActions.INIT_ERROR,
      });

      getHistory().push('/watchlist');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: watchlistFormActions.CREATE_STARTED,
      });

      await WatchlistService.create(values);

      dispatch({
        type: watchlistFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.watchlist.create.success'),
      );

      getHistory().push('/watchlist');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: watchlistFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values, redirect=true) => async (dispatch) => {
    try {
      dispatch({
        type: watchlistFormActions.UPDATE_STARTED,
      });

      await WatchlistService.update(id, values);

      dispatch({
        type: watchlistFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.watchlist.update.success'),
      );

      if (redirect) {
        getHistory().push('/watchlist');
      }
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: watchlistFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default watchlistFormActions;
